export default __webpack_public_path__ + "static/media/USER_ICONA.b05181f5.svg";